// Registers /sw.js once on page load. No-ops in dev mode (Vite HMR conflicts
// with SW) and in environments without `navigator.serviceWorker` (Node tests,
// very old browsers). All failures are swallowed — the Service Worker is a
// progressive enhancement, never load-bearing.

export interface RegisterSwOptions {
  /** Master toggle. Defaults to `!import.meta.env.DEV` in builds. */
  enabled?: boolean;
  /** Registration scope. Defaults to '/' (whole share-web domain). */
  scope?: string;
  /** SW script URL. Defaults to '/sw.js' (matches public/sw.js → dist/sw.js). */
  swUrl?: string;
}

export async function registerServiceWorker(
  opts: RegisterSwOptions = {},
): Promise<ServiceWorkerRegistration | null> {
  const enabled = opts.enabled ?? !import.meta.env.DEV;
  if (!enabled) return null;
  if (typeof navigator === 'undefined' || !navigator.serviceWorker) return null;
  try {
    const reg = await navigator.serviceWorker.register(
      opts.swUrl ?? '/sw.js',
      { scope: opts.scope ?? '/' },
    );
    return reg;
  } catch (err) {
    console.warn('[sw] register failed', err);
    return null;
  }
}
